<div #modalContents aria-modal="true" role="dialog" aria-labelledby="modalTitle">
  <!-- モーダルの中身が入ります -->
  <div class="p-form-layout04">
    <ng-container *ngFor="let flight of segmentInformationList">
      <div class="p-form-layout04__item">
        <div class="p-form-layout04__item-title p-form-layout04__item-title--l">
          <div class="p-form-layout04__item-title-label p-form-layout04__item-title-label--em">
            <div class="p-form-layout04__item-airport">
              <span class="p-form-layout04__item-airport-departure">
                {{ getAirportName(flight?.departure?.locationCode, flight?.departure?.locationName) }}
              </span>
            </div>
          </div>
        </div>
        <div class="p-input-block02">
          <ng-container *ngFor="let traveler of travelersByINF">
            <div class="p-input-block02__item" *ngIf="isLoungeExist(flight?.id, traveler?.id)">
              <div
                class="p-input-block02__item-title p-input-block02__item-title--m p-input-block02__item-title--has-text"
              >
                <div class="p-input-block02__item-title-label p-input-block02__item-title-label--em">
                  {{ getPassengerName(traveler) }}
                </div>
                <div class="p-input-block02__item-title-lead">
                  {{ getPassengerLabel(traveler?.passengerTypeCode) }}
                </div>
              </div>

              <div
                *ngIf="isAccompanyingTraveler"
                class="p-input-block02__item-title p-input-block02__item-title--m p-input-block02__item-title--has-text"
              >
                <div class="p-input-block02__item-title-label">{{ getAccompanyingPassenger(traveler) }}</div>
                <div class="p-input-block02__item-title-lead">
                  {{ getAccompanyingPassengerLabel(traveler) }}
                </div>
              </div>
              <div class="p-input-block02__row">
                <div class="p-input-block02__row-body">
                  <div class="p-input-block02__row-body-item">
                    <asw-lounge-cataloge
                      [flightId]="flight?.id"
                      [travelerId]="traveler?.id"
                      (changeLounge)="loungeSelectionValueChangeProcessing($event)"
                    ></asw-lounge-cataloge>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div id="serviceRecommendationArea"></div>
  </div>
  <!-- //モーダルの中身が入ります -->
</div>
